export default __webpack_public_path__ + "static/media/chat.7b982fe5.svg";